import { ErrorPage } from '../components/errors/errorPage';

export default function Custom404() {
  return <ErrorPage title={`Oops, we can't find the page you're looking for.`} />;
}
